//= require viewer/dist/crocodoc.viewer
import Crocodoc from 'viewer/dist/crocodoc.viewer'

// This package is a bit funky, loading it with webpack
// requires you to instantiate the namespace manually
window.Crocodoc = Crocodoc(window.jQuery)
